
import tableLoading from '@/components/tableLoading';
import TaxiCard from '@/components/TaxiCard'
import RentalHeader from '@/components/core/RentalHeader';
import NoContent from '@/components/customer-content/NoContent'
import CheckoutModal from '@/components/modals/CheckoutModal'
import moment from "moment";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueTimepicker from 'vue2-timepicker'
import RangeSlider from 'vue-range-slider'
// you probably need to import built-in style
import 'vue-range-slider/dist/vue-range-slider.css'
import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
export default {
  // layout: 'details-page',
  scrollToTop: true,
  components: {
    RentalHeader,
    TaxiCard,
    NoContent,
    tableLoading,
    CheckoutModal,
    DatePicker,
    VueTimepicker,
    RangeSlider,
    DateRangePicker
  },

  head() {
    return {
      title: this.title + " | Goa App",
      meta: [{
        hid: 'description',
        name: 'description',
        content: this.description
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: 'taxi in goa airport, taxi goa airport, prepaid taxi in goa airport, taxi goa airport to calangute, taxi goa airport to candolim, taxi goa airport to arambol, taxi goa airport to ashvem, taxi goa airport to agonda, taxi goa airport to palolem, taxi goa airport to baga, madgaon railway station to goa airport taxi fare'
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: this.title
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: this.description
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: this.title + " | Goa App"
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: this.description
      },
      { hid: 'og:image:alt',
        property: 'og:image:alt',
        content: this.title ? this.title : 'Book Taxi in Goa Airport'
      },
      { hid: 'og:image',
        property: 'og:image',
        content: this.$config.siteUrl + '/img/meta-imgs/taxi-meta-image.webp'
      },
      { hid: 'image',
        property: 'image',
        content: this.$config.siteUrl + '/img/meta-imgs/taxi-meta-image.webp'
      },
      { hid: 'twitter-image',
        property: 'twitter:image',
        content: this.$config.siteUrl + '/img/meta-imgs/taxi-meta-image.webp'
      },
      ],
      link: [
        {
          rel: 'stylesheet',
          href: 'https://cdn.jsdelivr.net/npm/vue2-timepicker@1.1.5/dist/VueTimepicker.css',

        }
      ],
      script: [{
        src: 'https://cdn.jsdelivr.net/npm/vue2-timepicker@1.1.5/dist/VueTimepicker.umd.min.js'
      }],
    }
  },
  data() {
    return {
      title: 'Taxi in Goa Airport - Book Now through Goa App',
      description: 'taxi in goa airport, taxi goa airport, prepaid taxi in goa airport, taxi goa airport to calangute, taxi goa airport to candolim, taxi goa airport to arambol, taxi goa airport to ashvem, taxi goa airport to agonda, taxi goa airport to palolem, taxi goa airport to baga, madgaon railway station to goa airport taxi fare',
      selected: null,
      sourcesList: [],
      destList: [],
      categories: null,
      amenities: null,
      selectedVehicleCity: 0,
      selectedVehicle: null,
      selectedVehicleCityData: {
        name: null,
        id: null
      },
      form: {
        dropDate: null,
        pickUpDate: null,
        pickUpTime: {
          HH: "09",
          mm: "00",
        },
        dropTime: {
          hh: "09",
          mm: "00",
          a: 'am'
        },
        newPickUpTime: '09:00 am',
      },
      searchObject: null,
      selectedValue: null,
      search: null,
      dropValue: null,
      isSearchClicked: false,
      applyFilterClicked: false,
      listings: {},
      loading: true,
      listingLoading: false,
      addToCartLoading: false,
      bookNowLoading: false,
      vehicleDetails: null,
      selectedDeal: -1,
      selectedDealData: null,
      displayTime: null,

      //new UI vars
      sectionId: 0,
      referral: null,
      mobilePickUpDate: null,
      mobileDropOffDate: null,
      citysearch: '',
      mobtimePickerList: ["00:00 am", "01:00 am", "02:00 am", "03:00 am", "04:00 am", "05:00 am", "06:00 am", "07:00 am",
        "08:00 am", "09:00 am", "10:00 am", "11:00 am", "12:00 pm", "01:00 pm", "02:00 pm", "03:00 pm",
        "04:00 pm", "05:00 pm", "06:00 pm", "07:00 pm", "08:00 pm", "09:00 pm", "10:00 pm", "11:00 pm"],
      sec1visible: true,

      dateRangeEx: {
        startDate: null,
        endDate: null
      },
      mobDateRangeEx: {
        startDate: null,
        endDate: null
      },
      onHoverFinishDate: null,
      mobileDateTimeValue: null,
      popUpPickUpTime: '09:00 am',
      dealsData: null,
    };

  },
  fetchOnServer: false,
  async fetch() {
    //Get the list of page data
    this.categories = await fetch(this.$config.fetchUrl +
      '/api/vehicleCategories').then(res => res.text());
    this.categories = this.getCryptKey(this.categories);
    this.amenities = await fetch(this.$config.fetchUrl +
      '/api/vehicleAmenities').then(res => res.text());
    this.amenities = this.getCryptKey(this.amenities);
    this.sourcesList = await fetch(this.$config.fetchUrl +
      '/api/sources').then(res => res.text());
    this.sourcesList = this.getCryptKey(this.sourcesList);
    this.$nextTick(() => {
      if (this.sourcesList && this.sourcesList.length > 0) {
        this.setSourceDest();
      }
    })
  },
  computed: {
    // Used for search function on the page
    filteredCityList() {
      if (this.sourcesList) {
        return this.sourcesList.filter(city => {
          return (city.name.toLowerCase().includes(this.citysearch.toLowerCase().trim()))
        })
      } else {
        return []
      }
    },
    filteredDestList() {
      if (this.destList) {
        return this.destList.filter(city => {
          return (city.name.toLowerCase().includes(this.citysearch.toLowerCase().trim()))
        })
      } else {
        return []
      }
    }
  },
  destroyed() {
    if (document && document.getElementsByClassName('modalOverflow'))
      document.body.classList.remove('modalOverflow')
    if (document && document.getElementById('filterClose'))
      document.getElementById('filterClose').click();
  },
  mounted() {
    if (localStorage.getItem("refCode") != (null || undefined)) {
        this.referral = localStorage.getItem("refCode");
      }
      if (localStorage.getItem("taxiBooked")) {
        localStorage.removeItem('taxiBooked');
      }
    this.setInitialPickUpToday();
    this.setInputTime("09:00 am")
  },
  methods: {

    setSourceDest(){
      if (this.sourcesList && this.sourcesList.length > 0) {
            this.searchObject = this.sourcesList.find(x => x.type === 0 && x.default === true);
            this.search = this.searchObject && this.searchObject._id ? this.searchObject._id : null;
            let drop = this.sourcesList.find(x => x.type === 1 && x.default === true);
            this.dropValue =  drop && drop._id ? drop._id : null;
            this.destList =  this.sourcesList.filter(x => x.type == 1);
          }
    },

    pickupchanged(){
      let searchObj =  this.sourcesList.find(x => x._id == this.search);
      let drop = searchObj ? this.sourcesList.find(x => x.type != searchObj.type && x.default === true) : null;
            this.dropValue =  drop && drop._id ? drop._id : null;
            this.destList =  this.sourcesList.filter(x => x.type != searchObj.type);

    },


    getCityName(val) {
      if (val) {
        const filteredCity = this.sourcesList.filter(x => x._id == val);
        return filteredCity && filteredCity.length > 0 ? filteredCity[0].name : null
      }
      return null;
    },

    onPickUpModalOpen(modalType) {
      if (modalType == 'pickup') {
        this.mobilePickUpDate = this.form.pickUpDate ? this.form.pickUpDate : null;
        if(this.dateRangeEx.startDate)
        this.mobDateRangeEx.startDate =  this.dateRangeEx.startDate
        this.popUpPickUpTime = this.form.newPickUpTime
      }
      if (modalType == 'dropoff') {
        this.mobileDropOffDate = this.form.dropDate ? this.form.dropDate : null;
      }

    },

    setInitialPickUpToday() {
      const today = new Date();
      var currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 1);
      var nextDate = new Date();
      nextDate.setDate(nextDate.getDate() + 2);
      var format = 'hh:mm:ss'
      var time = moment(today, format)
      var beforeTime = moment('00:00:00', format);
      var afterTime = moment('17:00:00', format);
      if (time.isBetween(beforeTime, afterTime)) {
        this.form.pickUpDate = currentDate;
        this.dateRangeEx.startDate = currentDate;
        this.dateRangeEx.startDate = this.dateRangeEx.startDate.setHours(9, 0, 0)
        this.dateRangeEx.startDate = new Date(this.dateRangeEx.startDate)
      } else {
        this.form.pickUpDate = nextDate;
        this.dateRangeEx.startDate = nextDate;
        this.dateRangeEx.startDate = this.dateRangeEx.startDate.setHours(9, 0, 0)
        this.dateRangeEx.startDate = new Date(this.dateRangeEx.startDate)
      }
    },

    dateFormat(classes, date) {
      const today = new Date();
      var currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 1);
      var format = 'hh:mm:ss'
      var time = moment(today, format)
      var beforeTime = moment('00:00:00', format);
      var afterTime = moment('17:00:00', format);
      var startDate = null;
      if (!classes.disabled) {
        if (time.isBetween(beforeTime, afterTime)) {
          classes.disabled = moment(date).format("YYYY/MM/DD") <= moment(today).format("YYYY/MM/DD") || (startDate ?
            moment(date).format("YYYY/MM/DD") == moment(startDate).format("YYYY/MM/DD") : '')
        } else {
          classes.disabled = moment(date).format("YYYY/MM/DD") <= moment(currentDate).format("YYYY/MM/DD") || (
              startDate ? moment(date).format("YYYY/MM/DD") == moment(startDate).format("YYYY/MM/DD") : '')
        }
      }
      return classes
    },

    setInputTime(value) {
      let val = moment(value, ["h:mm a"]).format("HH:mm");
      const [h, m] = val.split(":");
      const ms = new Date().setHours(h, m, 0);
      this.mobileDateTimeValue = new Date(ms)
    },

    mobilePickUpSearchClicked() {
      if (this.mobDateRangeEx && this.mobDateRangeEx.startDate) {
        this.dateRangeEx.startDate = this.mobDateRangeEx.startDate;
        this.dateRangeEx.startDate = new Date(this.dateRangeEx.startDate)
      }
      if(this.popUpPickUpTime)
      this.form.newPickUpTime = this.popUpPickUpTime;
    },

    // new ui end

    goToAccordionSec(value) {
      if (value)
        window.scrollTo(0, 0)
      //this.scrollToJsRentals('section-2')
    },

    setSelected(value) {
      this.searchObject = this.sourcesList.find(x => x._id === value);
    },

    // TO get SUBSCRIPTIONS using pagination
    getListings(source = null, dest = null, date = null , time = null) {
      this.$refs.bookingForm.validate().then((success) => {
        if (!success || !source || !dest || !date) {
          this.formError = "One or more incorrect fields present, please fix.";
        } else {
          this.listings = [];
          this.listingLoading = true;
          let cityid = 0;
          var formData = new URLSearchParams();
          formData.append("source", source ? source : cityid);
          formData.append("destination", dest ? dest : cityid);
          formData.append("date", date ? moment(date).format("YYYY/MM/DD") : null);
          formData.append("time", time ? time : null);

          // Add header for the API
          const headers = {
            "Content-Type": "application/x-www-form-urlencoded",
          };
          // AXIOS api call to add review api
          this.$axios.post(`/api/taxiRoutesPrices/getTaxisInRoute`, formData, {
            headers: headers
          })
            .then(response => {
              this.applyFilterClicked = false;
              this.sectionId = 1;
              this.sec1visible = true;
              this.scrollToJsRentals('section-2')
              let value = this.getCryptKey(response.data);
              if(value && value.length > 0){
                this.listings = value.filter(x => x.taxi != null);
              this.selectedVehicle = this.listings[0];
              }

              this.$nextTick(() => {
                this.listingLoading = false;
                this.applyFilterClicked = false;
              })
            })
            .catch(error => {
            this.$bvModal.show('noTaxiModal')
              this.$nextTick(() => {
                this.listingLoading = false;
                this.applyFilterClicked = false;
              })
            })
            .finally(() => {
              this.$nextTick(() => {
                //this.scrollToSectionIntoView('listing-card');
                this.listingLoading = false;
                this.applyFilterClicked = false;
              })
            })
        }
      })
    },
    disabledBeforeToday(date) {
      const today = new Date();
      var currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 1);
      var format = 'hh:mm:ss'
      var time = moment(today, format)
      var beforeTime = moment('00:00:00', format);
      var afterTime = moment('17:00:00', format);
      if (time.isBetween(beforeTime, afterTime)) {
        return date <= today;
      } else {
        return date <= currentDate;
      }
    },

    setGetDealsClicked(value) {
      if (value != null || value != undefined) {
        this.dealsData = value;
        this.goToCheckout(value);
      }
    },

    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/thumbnail-square.svg`)
    },

    goToCheckout(value) {
      if (localStorage.getItem("authToken") != (null || undefined)) {
        this.token = localStorage.getItem("authToken");
        if (value && value.id && this.search && this.dropValue && this.dateRangeEx.startDate && this.form.newPickUpTime) {
          this.addToCartLoading = true;
          // Create formData instance to pass the data to the API
          var formData = new URLSearchParams();
          formData.append("source", this.search ? this.search : null);
          formData.append("destination", this.dropValue ? this.dropValue : null);
          formData.append("date", this.dateRangeEx.startDate ? moment(this.dateRangeEx.startDate).format("YYYY/MM/DD") : null);
          formData.append("time", this.form.newPickUpTime ? this.form.newPickUpTime : null);
          formData.append("taxiRoutePrice", value.id);
          formData.append("quantity", value.quantity);
          if (this.referral) {
            formData.append("agent", this.referral);
          }
          // Add header for the API
          const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': this.token
          }
          // AXIOS api call to add categories api
          this.$axios
            .post("/api/taxiCarts/app/addToTaxiCart", formData, {
              headers: headers
            })
            .then(response => {
              this.addToCartLoading = false;
              this.$router.push({
                path: "/taxi-checkout"
              });
            })
            .catch(error => {
              this.$bvModal.show('noDealsModal')
              this.addToCartLoading = false;
            })
            .finally(() => {
              this.addToCartLoading = false;
            });
        }
      } else {
        this.$bvModal.show('checkout')
      }
    },
    userCreated() {
      this.goToCheckout(this.dealsData)
    },

    taxiCounter(){
          var formData = new URLSearchParams();

          // Add header for the API
          const headers = {
            "Content-Type": "application/x-www-form-urlencoded",
          };
          // AXIOS api call to add review api
          this.$axios.post(`/api/callCounter/taxi`, formData, {
            headers: headers
          })
            .then(response => {
              
            })
    }
  }
}
